import {FunnelKey, RoleKeyPair} from "./Keys";
import {Property} from "csstype";
import {VisibleCell} from "./VisibleCell";

export type RoleCellData = string;
export const INITIAL_ROLE_CELL_DATA = VisibleCell.NOT_JOINABLE_VALUE;

export class RoleCell {

    private readonly role_key_pair: RoleKeyPair;
    private readonly name: RoleCellData;

    constructor(role_key_pair: RoleKeyPair, name: RoleCellData) {
        this.role_key_pair = role_key_pair;
        this.name = name;
    }

    get KeyPair(): RoleKeyPair {
        return this.role_key_pair;
    }

    get Key(): FunnelKey {
        return this.role_key_pair.FunnelKey;
    }

    get Name(): string {
        return this.name;
    }

    get OstensibleName(): string {
        return VisibleCell.getOstensibleValue(this.name);
    }
}

type VisibleRoleCellState = {
    IsSelected: boolean;
    BackgroundColor: Property.BackgroundColor;
    GridColumn: string;
    PrevRoleKeyPairOrNull: RoleKeyPair | null;
    NextRoleKeyPairOrNull: RoleKeyPair | null;
    AboveRoleKeyPairOrNull: RoleKeyPair | null;
    BelowRoleKeyPairOrNull: RoleKeyPair | null;
    IsJoinable: boolean;
    IsSeparatable: boolean;
    JoinedKeys: FunnelKey[];
    Collaborators: string[];
}

export class VisibleRoleCell extends RoleCell {

    private readonly state: VisibleRoleCellState;

    constructor(role_cell: RoleCell, state: VisibleRoleCellState) {
        super(role_cell.KeyPair, role_cell.Name);
        this.state = state;
    }

    get State(): VisibleRoleCellState {
        return this.state;
    }

    isChangeableName(name: string) {
        return VisibleCell.isChangeableValue(this.Name, name);
    }
}
